export default __webpack_public_path__ + "static/media/gallery-image-5.cf4ff595.png";